import { render } from "./PageSoumissionBescPage.vue?vue&type=template&id=ad1e8a2e&ts=true"
import script from "./PageSoumissionBescPage.vue?vue&type=script&lang=ts"
export * from "./PageSoumissionBescPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__